import { Paragraph } from "@/components/ui-library/typography/Body"
import { BlokProps } from "@helpers/StoryblokHelpers"
import { PhoneLinkStoryblok } from "@storyblok-types"

export const PhoneLink = ({ blok }: BlokProps<PhoneLinkStoryblok>) => {
  return (
    <Paragraph size="small" className="block py-2 lg:py-2" asChild>
      <span>
        {blok.label} <a href={`tel:${blok.phone_number}`}>{blok.phone_number}</a>
      </span>
    </Paragraph>
  )
}

export default PhoneLink
